import { AccordionDetails, Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Stack } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVChecklistInformedConsentVerification } from 'src/types/SIVChecklist';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  InformedConsentVerificationMandatory,
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  MandatoryData
} from './useSivChecklist';
import { setIsSaveButtonDisable } from 'src/store/sivCheckList';

export interface IInformedConsentVerification {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  setSaveDisable: (saveDisable: boolean) => void;
  informedConsentVerificationData: ISIVChecklistInformedConsentVerification;
  updateIinformedConsentVerification: (data: ISIVChecklistInformedConsentVerification) => void;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: InformedConsentVerificationMandatory;
  validateinformedConsentVerification: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const InformedConsentVerification: React.FunctionComponent<IInformedConsentVerification> = ({
  getSivChecklistData,
  saveDisable,
  setSaveDisable,
  isChange,
  setIsChange,
  informedConsentVerificationData,
  updateIinformedConsentVerification,
  isUpdate,
  updateSIVChecklistMandatoryData,
  mandatory,
  validateinformedConsentVerification,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);

  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_checklist');
  const user = useUser();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg, checklistInformedConsent } = useFieldTranslation();
  const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);
  const saveButtonDisable: any = useAppSelector(state => state.sivCheckList.disableSaveButtonProps);

  const handleInformedConsentData = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    dispatchApp(clearMessage());
    if (e.target.type === 'radio' && value === 'Y') {
      updateIinformedConsentVerification({
        ...informedConsentVerificationData,
        [e.target.name]: value,
        [`${e.target.name}_comm`]: ''
      });
      //setValidate({ ...validate, [e.target.name]: false });
      updateSIVChecklistMandatoryData('informedConsentVerification', { ...mandatory, [e.target.name]: false });
    } else {
      if (e.target.name === 'siv_checklist_ic_translation' && e.target.value === 'N') {
        updateIinformedConsentVerification({
          ...informedConsentVerificationData,
          // siv_checklist_translation_service: 'NA',
          [e.target.name]: value
        });
      } else {
        updateIinformedConsentVerification({ ...informedConsentVerificationData, [e.target.name]: value });
      }
    }
    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && value !== '')) {
        //setValidate();
        updateSIVChecklistMandatoryData('informedConsentVerification', { ...mandatory, [validateKey]: true });
      } else {
        //setValidate({ ...mandatory, [validateKey]: false });
        updateSIVChecklistMandatoryData('informedConsentVerification', { ...mandatory, [validateKey]: false });
      }
    }
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, siteAdequacy: false }));
    setConfirmExitValue(dispatch, true);
    //setIsChange(true);
    //setIsChanged(true);
  };

  const updateInformedConsentData = async () => {
    const clonedObj: any = { ...informedConsentVerificationData };
    if (
      informedConsentVerificationData.siv_checklist_ic_translation === 'N' &&
      informedConsentVerificationData.siv_checklist_translation_service == ''
    ) {
      clonedObj.siv_checklist_translation_service = 'NA';
    }
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData.id,
        siv_checklist: { step_one: { informed_consent: clonedObj } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (
            informedConsentVerificationData.siv_checklist_ic_template !== null &&
            informedConsentVerificationData.siv_checklist_ic_translation !== null &&
            informedConsentVerificationData.siv_checklist_translation_service !== null &&
            informedConsentVerificationData.siv_checklist_translation_service !== 'NA'
          ) {
            await sendRequest('update_sivChecklist_data', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivChecklistData('informedConsentVerification', false);
            setIsChange('Step1', 'informedConsentVerification', false);
            //setIsChange(false);
            //setIsChanged(false);
            setConfirmExitValue(dispatch, false);
            // store.dispatch(setSnackbarMessage('Informed Consent data is successfully saved', 'success'));
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else if (informedConsentVerificationData.siv_checklist_ic_translation !== 'N') {
            // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
          //}
          if (informedConsentVerificationData.siv_checklist_ic_translation === 'N') {
            if (
              informedConsentVerificationData.siv_checklist_ic_template !== null &&
              informedConsentVerificationData.siv_checklist_ic_translation !== null
            ) {
              await sendRequest('update_sivChecklist_data', options);
              getSivChecklistData('informedConsentVerification', false);
              setIsChange('Step1', 'informedConsentVerification', false);
              //setIsChange(false);
              //setIsChanged(false);
              setConfirmExitValue(dispatch, false);
              // store.dispatch(setSnackbarMessage('Informed Consent data is successfully saved', 'success'));
              dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
            } else {
              // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
              dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
            }
          }
        }
        if (!isUpdate) {
          if (
            informedConsentVerificationData.siv_checklist_ic_template !== null &&
            informedConsentVerificationData.siv_checklist_ic_translation !== null &&
            informedConsentVerificationData.siv_checklist_translation_service !== null
          ) {
            await sendRequest('create_sivChecklist_data', options);
            getSivChecklistData('informedConsentVerification', true);
            setIsChange('Step1', 'informedConsentVerification', false);
            //setIsUpdate(true);
            //setIsChange(false);
            //setIsChanged(false);
            // store.dispatch(setSnackbarMessage('Informed Consent data is successfully saved', 'success'));
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
            setConfirmExitValue(dispatch, false);
          } else {
            // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (validateinformedConsentVerification) {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      } else {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, siteAdequacy: true }));
    } catch (e) {
      // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab protocol-compliance">
        <Grid container className="checklist-radio-actions">
          <Grid md={12}>
            <Grid container>
              <Grid md={9}>
                {checklistInformedConsent.label1} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    value={informedConsentVerificationData.siv_checklist_ic_template}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_ic_template"
                    onChange={handleInformedConsentData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container>
              <Grid md={9}>
                {/* Does the site anticipate the need for ICF translations in any additional languages? */}
                {checklistInformedConsent.label2}? <span style={{ color: 'red' }}>* </span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    value={informedConsentVerificationData.siv_checklist_ic_translation}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_ic_translation"
                    onChange={handleInformedConsentData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container>
              <Grid md={9}>
                {checklistInformedConsent.label3}? <span style={{ color: 'red' }}>*</span>{' '}
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    value={informedConsentVerificationData.siv_checklist_translation_service}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_translation_service"
                    onChange={handleInformedConsentData}
                  >
                    <FormControlLabel
                      disabled={
                        !isDisable ||
                        saveDisable ||
                        !checkedInStartDate ||
                        informedConsentVerificationData.siv_checklist_ic_translation === 'N'
                      }
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={
                        !isDisable ||
                        saveDisable ||
                        !checkedInStartDate ||
                        informedConsentVerificationData.siv_checklist_ic_translation === 'N'
                      }
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-end">
          <Stack spacing={2} direction="row">
            {isDisable ? (
              <Button
                onClick={updateInformedConsentData}
                variant="text"
                disabled={saveButtonDisable.siteAdequacy || !checkedInStartDate}
              >
                SAVE
              </Button>
            ) : (
              ''
            )}{' '}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default InformedConsentVerification;
